import '../../blocks/installer-form/installer-form.scss';
import './base-settings.scss';
import PathEditor from '../../blocks/path-editor/path-editor';
import ManageOldUpgrade from '../../blocks/manage-old-upgrade/manage-old-upgrade';
import InstallationSettingsBlock from '../../blocks/installation-settings/installation-settings';
import '../../blocks/ring-breadcrumbs/ring-breadcrumbs.scss';
import BaseUrl from '../../blocks/base-url/base-url';
import InstallerResource from '../../blocks/resource/resource';
import ExternalValidator from '../../blocks/external-validator/external-validator';
import UrlHelper from '../../blocks/url-helper/url-helper';

import RingTooltip from '@jetbrains/ring-ui/components/tooltip-ng/tooltip-ng';
import RingConfirm from '@jetbrains/ring-ui/components/confirm-ng/confirm-ng';

import BaseSettingsController from './base-settings__controller';
import FileUpload from '../../blocks/file-upload/file-upload';

export default angular.module('installer.base-settings', [
  InstallerResource.name,
  PathEditor.name,
  BaseUrl.name,
  ExternalValidator.name,
  UrlHelper.name,
  InstallationSettingsBlock.name,
  RingConfirm,
  RingTooltip,
  ManageOldUpgrade,
  FileUpload.name
]).
  constant('baseStepUrl', '/install/base').
  controller('BaseSettingsController', BaseSettingsController).
  config($provide => {
    $provide.decorator('RingMessageBundle', ($delegate, i18n) => {
      // eslint-disable-next-line camelcase
      $delegate.form_pattern = () => // jshint ignore:line
        i18n('Should not contain not valid symbols');
      return $delegate;
    });
  }).
  config(($routeProvider, baseStepUrl) => {
    $routeProvider.
      when(baseStepUrl, {
        template: require('./base-settings.html'),
        controller: 'BaseSettingsController as ctrl',
        reloadOnSearch: false
      });
  });



// WEBPACK FOOTER //
// ./src/pages/base-settings/base-settings.js